<template>
    <div>
        <input type="hidden" name="cartUpdate" v-model="$store.state.cart.cartUpdate">
    </div>

</template>

<script>
    export default {
        methods: {

        },
        mounted() {

        },
        computed: {

        },
        data() {
            return {

            };
        }
    }
</script>
